import createIcon from '../../createIcon';

/**
 * @component @name Person2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMzkgMTQuNTZDMTYuNzEgMTMuNyAxNC41MyAxMyAxMiAxM0M5LjQ3IDEzIDcuMjkgMTMuNyA1LjYxIDE0LjU2QzQuNjEgMTUuMDcgNCAxNi4xIDQgMTcuMjJWMjBIMjBWMTcuMjJDMjAgMTYuMSAxOS4zOSAxNS4wNyAxOC4zOSAxNC41NloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05Ljc4IDEySDE0LjIyQzE1LjQzIDEyIDE2LjM2IDEwLjk0IDE2LjIgOS43NEwxNS44OCA3LjI5QzE1LjU3IDUuMzkgMTMuOTIgNCAxMiA0QzEwLjA4IDQgOC40MyA1LjM5IDguMTIgNy4yOUw3LjggOS43NEM3LjY0IDEwLjk0IDguNTcgMTIgOS43OCAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Person2 = createIcon('Person2', [
  [
    'path',
    {
      d: 'M18.39 14.56C16.71 13.7 14.53 13 12 13C9.47 13 7.29 13.7 5.61 14.56C4.61 15.07 4 16.1 4 17.22V20H20V17.22C20 16.1 19.39 15.07 18.39 14.56Z',
      key: 'j79e49',
    },
  ],
  [
    'path',
    {
      d: 'M9.78 12H14.22C15.43 12 16.36 10.94 16.2 9.74L15.88 7.29C15.57 5.39 13.92 4 12 4C10.08 4 8.43 5.39 8.12 7.29L7.8 9.74C7.64 10.94 8.57 12 9.78 12Z',
      key: 'o5npqt',
    },
  ],
]);

export default Person2;
